/* @flow */

import keymirror from 'keymirror';

const MapConstants = keymirror({
  MAP_SET_CENTER: null,
  MAP_SET_ZOOM: null,
  MAP_SET_BEARING: null,
  MAP_SET_PITCH: null,
  MAP_SET_VIEWPORT: null,
  MAP_SET_MARKER_HOVER: null,
  MAP_SET_POPUP: null,
  MAP_CLEAR_POPUP: null,
  MAP_ADD_ACTION: null,
  MAP_DELETE_ACTIONS: null,
});

export { MapConstants };
